import moment from 'moment';
import _ from 'underscore';
import jQuery from 'jquery';

function PromoterEventsCtrl($scope, $state, $stateParams, $q, $timeout, alertService, sdkVenueService, sdkUtils, eventService, dateUtilsService, managementUserService, organizationService, userPreferencesService, $location, venueService, urlService, visibilityHelpersService, mapperService, managementUserOrganizationMemberService) { //eslint-disable-line
  const currentUserOrganization = organizationService.getCurrentOrganization();
  const organizationMember = managementUserOrganizationMemberService.getCurrentOrganizationMember();

  /**
   * @desc Loading state
   */
  $scope.loading = true;

  $scope.eventPageSize = 5;

  $scope.eventSearchType = 'NAME';

  $scope.eventSort = 'dateStart';

  $scope.isPrivate = function (event) {
    return visibilityHelpersService.isPrivate(event);
  };

  $scope.linkCopied = function (event, $event) {
    if ($event) $event.preventDefault();

    event.showCopiedTooltip = true;
  };

  $scope.changeVenue = _changeVenue;

  $scope.getPreviousPageOfEvents = function ($event) {
    if ($event) {
      $event.preventDefault();
    }

    $scope.loading = true;
    $scope.eventSort = '-dateStart';
    $scope.eventSearch.date = null;

    return _getEvents()
      .then(() => {
        $scope.loading = false;
      });
  };

  $scope.getNextPageOfEvents = function ($event) {
    if ($event) {
      $event.preventDefault();
    }

    $scope.loading = true;
    $scope.eventSort = 'dateStart';
    $scope.eventSearch.date = null;

    return _getEvents()
      .then(() => {
        $scope.loading = false;
      });
  };

  $scope.eventSearch = {
    search: null,
    date: null
  };

  $scope.changeSearchType = function (type, $event) {
    if ($event) {
      $event.preventDefault();
    }

    if (type === 'NAME') {
      delete $scope.eventSearch.date;
    } else if (type === 'DATE') {
      delete $scope.eventSearch.search;

      $timeout(() => {
        jQuery('.event-date-range-picker').trigger('click');
      }, 300);
    }

    $scope.eventSearchType = type;
  };

  $scope.searchEvents = _.debounce(() => {
    $scope.loading = true;

    return _getEvents()
      .then(() => {
        $scope.loading = false;
      });
  }, 300);

  $scope.searchEventsByDate = function () {
    if (!$scope.eventSearch.date) return null;

    $scope.loading = true;

    return _getEvents()
      .then(() => {
        $scope.loading = false;
      });
  };

  $scope.clearEventSearch = function ($event) {
    if ($event) {
      $event.preventDefault();
    }

    delete $scope.eventSearch.date;
    delete $scope.eventSearch.search;

    $scope.firstEvent = null;
    $scope.lastEvent = null;

    $scope.loading = true;

    //kinda of hacky, but this handle if we're using a DATE search and hit 'X' to clear
    //we reset back to 'NAME' search to get the right event list results, then flip back to 'DATE' to keep it on the date picker
    //TODO: find a better way, causes a flash of the name input field
    const oldSearchType = $scope.eventSearchType;

    $scope.eventSearchType = 'NAME';

    return _getEvents()
      .then(() => {
        $scope.loading = false;

        if (oldSearchType === 'DATE') {
          $scope.eventSearchType = 'DATE';
        }
      });
  };

  _getVenues()
    .then(() => {
      if (!$scope.venues.length) {
        $scope.noVenues = true;
        $scope.loading = false;

        return null;
      }

      return _getEvents()
        .finally(() => {
          $scope.loading = false;
        });
    });

  function _changeVenue(venue, $event) {
    if (!venue) return;
    if ($event) $event.preventDefault();

    $scope.venue = venue;
    $scope.venueId = venue.id;

    userPreferencesService.setDefaultVenue($scope.venue.id);

    venueService.setCurrentVenue(venue);

    $location.search('venueId', $scope.venue.id);

    $scope.loading = true;

    _getEvents()
      .finally(function () {
        $scope.loading = false;
      });
  }

  function _getVenues() {
    return sdkVenueService.listByOrganizationId(currentUserOrganization.id, {
        fields: [
          'name',
          'id',
          'default_poster',
          'schedule',
          'company',
          'slug',
          'enable',
          'location'
        ].join(',')
      })
      .then(function (venues) {
        $scope.venues = venues;

        if (!$scope.venues.length) {
          $scope.noVenues = true;
          return;
        }

        $scope.venuesIndexedById = _.indexBy($scope.venues, 'id');

        let defaultVenue = _.findWhere($scope.venues, {
          id: $stateParams.venueId ? $stateParams.venueId : userPreferencesService.getDefaultVenue()
        });

        defaultVenue = defaultVenue || $scope.venues[0];

        $scope.venue = $scope.venue || defaultVenue;

        venueService.setCurrentVenue($scope.venue);
      })
      .catch(function (error) {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function _getEvents() {
    const today = moment();

    const specificDateSearch = $scope.eventSearchType === 'DATE' && $scope.eventSearch.date;
    const specificNameSearch = $scope.eventSearchType === 'NAME' && $scope.eventSearch.search;

    let start = $scope.eventSearchType === 'DATE' && $scope.eventSearch.date ?
      dateUtilsService.toUTCTimestampWithoutTime($scope.eventSearch.date) :
      dateUtilsService.toUTCTimestampWithoutTime(today);
    let end = $scope.eventSearchType === 'DATE' ? start : null; //if a specific date is selected, must pass an endDate

    let after;
    let sort = $scope.eventSort;

    if (!specificDateSearch) {
      if (sort === 'dateStart' && $scope.lastEvent) {
        start = null;
        end = null;
        after = $scope.lastEvent.id;
        sort = `${sort} name`;
      } else if (sort === '-dateStart' && $scope.firstEvent) {
        start = null;
        end = null;
        after = $scope.firstEvent.id;
        sort = `${sort} -name`;
      } else {
        sort = `${sort} name`;
      }

      if ($scope.eventSearch.search) {
        start = null;
        end = null;
        after = null;
      }
    }

    const query = {
      start,
      end,
      sort,
      limit: !specificDateSearch && !specificNameSearch ? $scope.eventPageSize : null,
      after,
      name: $scope.eventSearch.search || null
    };

    return eventService.listByVenueId($scope.venue.id, query)
      .then(events => {
        $scope.events = events.map(function (event) {
          const mappedEvent = mapperService.mapEventToUI(event);

          mappedEvent.venue = $scope.venuesIndexedById[event.venue];

          const seoPathname = (mappedEvent.seoPathname) ? mappedEvent.seoPathname : mappedEvent.id;

          mappedEvent.publicPageURL = urlService.getEventPublicPageUrl(seoPathname, {
            venue: $scope.venue.id,
            attributionId: organizationMember.id
          });

          return mappedEvent;
        });

        //store first and last IDs for paging
        if ($scope.events && $scope.events.length) {
          if ($scope.eventSort === 'dateStart') {
            $scope.lastEvent = $scope.events[$scope.events.length - 1];
            $scope.firstEvent = $scope.events[0];
          } else if ($scope.eventSort === '-dateStart') {
            $scope.firstEvent = $scope.events[$scope.events.length - 1];
            $scope.lastEvent = $scope.events[0];
          }
        } else {
          $scope.previousQuery = query;
        }
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }
}

PromoterEventsCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$q',
  '$timeout',
  'alertService',
  'jsSdk.venue',
  'jsSdk.utils',
  'jsSdk.event',
  'dateUtilsService',
  'jsSdk.managementUser',
  'organizationService',
  'userPreferencesService',
  '$location',
  'venueService',
  'urlService',
  'visibilityHelpersService',
  'mapperService',
  'managementUserOrganizationMemberService'
];

export default PromoterEventsCtrl;



// WEBPACK FOOTER //
// ./src/components/promoter/events/eventsCtrl.js